import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundDecimal'
})
export class RoundDecimalPipe implements PipeTransform {

  transform(number: string): string {
    // console.log("number ",number)
    let n = "";
    let redondeo = 0;
    if (number != "" && number != null) {
      n = number.replace(",","");
      redondeo = Math.round(parseFloat(n));
      return  redondeo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }else {
      return "";
    }

  }

}
